module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "menu-sidebar"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#button"
    }
  }, [_vm._v("Buttons")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#grid"
    }
  }, [_vm._v("Grid")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#form"
    }
  }, [_vm._v("Forms")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#icon"
    }
  }, [_vm._v("Icons")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c51e2e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuExamples.vue
// module id = 141
// module chunks = 1